export default {
  TaxTypeSelectorPage: 'TaxTypeSelectorPage',
  BusinessTypeSelectorPage: 'BusinessTypeSelectorPage',
  TaxInfoInputPage: 'TaxInfoInputPage',
};
